import React, { createContext, useContext, useState, useEffect } from 'react';

const OrderPauseContext = createContext();

export function OrderPauseProvider({ children }) {
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('mlk.orderPaused');
    if (stored !== null) {
      setIsPaused(JSON.parse(stored));
    }
  }, []);

  const togglePaused = () => {
    const newPaused = !isPaused;
    setIsPaused(newPaused);
    localStorage.setItem('mlk.orderPaused', JSON.stringify(newPaused));
  };

  return (
    <OrderPauseContext.Provider value={{ isPaused, togglePaused }}>
      {children}
    </OrderPauseContext.Provider>
  );
}

export function useOrderPause() {
  return useContext(OrderPauseContext);
}
